type ClassName = '' | 'text-critical-default' | 'text-success-default';

type Options = {
  invertColors?: boolean;
  reference?: number;
  threshold?: number;
};

type Value = number | null | undefined;

export default function changeColorClass(
  value: Value,
  options?: Options,
): ClassName {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '';
  }

  const threshold = options?.threshold ?? 0;
  const isAboveTreshold = Math.abs(value) >= threshold && value !== 0;

  if (!isAboveTreshold) {
    return '';
  }

  const invertColors = options?.invertColors ?? false;
  const reference = options?.reference ?? 0;
  const compareNumber = invertColors ? -1 * value : value;

  if (compareNumber > reference) {
    return 'text-success-default';
  }

  return 'text-critical-default';
}
